export const getStoreLocatorMarkerIcon = (icon: string) => ({
  url: icon,
});
